/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: ProductsbyCategoryRoutingModule
 * Purpose		: Routing module for ProductsbyCategory.
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/

import { NgModule }             from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { ProductsbyCategoryListComponent } from './ProductsbyCategoryList.component';
import { ProductsbyCategoryDetailsComponent } from './ProductsbyCategoryDetails.component';

const ProductsbyCategoryRoutes: Routes = [
	{ path: 'ProductsbyCategory',  component: ProductsbyCategoryListComponent },
	{ path: 'ProductsbyCategory/Details/:id', component: ProductsbyCategoryDetailsComponent },
];

@NgModule({
  imports: [
    RouterModule.forChild(ProductsbyCategoryRoutes)
  ],
  exports: [
    RouterModule
  ]
})

export class ProductsbyCategoryRoutingModule { }



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/ProductsbyCategory/ProductsbyCategory-routing.module.ts